import React from 'react';
import { useSearchParams } from 'react-router';

import { HighlightedText } from '@/shared/components/ui/highlighted-text/highlighted-text';
import { TSearchableResourceFieldsProps } from '@/shared/components/ui/searchable-resource-field/searchable-resource-field.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { truncateText } from '@/shared/utils/truncate-text';

export const SearchableResourceField: React.FC<
  TSearchableResourceFieldsProps
> = ({ value, queryParam, maxLength = Infinity }) => {
  const [searchParams] = useSearchParams();
  const { shouldTruncate, truncatedText } = truncateText(value, maxLength);

  const currentSearch = searchParams.get(queryParam) ?? '';

  if (shouldTruncate) {
    return (
      <Tooltip
        title={<HighlightedText text={value} searchTerm={currentSearch} />}
        disableHoverListener={false}
        disableTouchListener={false}
        disableFocusListener={false}
      >
        <span style={{ pointerEvents: 'auto' }}>
          <HighlightedText text={truncatedText} searchTerm={currentSearch} />
        </span>
      </Tooltip>
    );
  }

  return <HighlightedText text={value} searchTerm={currentSearch} />;
};
